var map = {
	"./budget-book.png": 722,
	"./event-graphia-dropped.jpg": 7409,
	"./event-graphia.jpg": 7159,
	"./flash.jpg": 3544,
	"./mokku.png": 1046,
	"./mun2017.jpg": 4631,
	"./plinth2016.jpg": 7072,
	"./plinth2017.jpg": 8616,
	"./smart-grid.png": 865,
	"./timespread.jpg": 4192,
	"./web-os.png": 5301,
	"./zento.jpg": 7472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8975;